import React, { useState } from "react";
import { Award } from "lucide-react";

const CofoundersSection = () => {
  const [selectedCofounder, setSelectedCofounder] = useState(null);

  const cofounders = [
    {
      id: 'tiago',
      name: 'Tiago',
      role: 'Founder & Senior Data Engineer',
      telegramHandle: 'tiago_m7',
      avatar: 'https://customer-assets.emergentagent.com/job_telegram-crypto-4/artifacts/q2t65g26_Tiago%20LOFI.jpg',
      description: "My name is Tiago, and I am a Senior Data Engineer with over 11 years of experience in the data analytics and business intelligence field. Since 2018, I have also been actively involved in the cryptocurrency industry, working as an advisor and venture capital investor. Beyond technical and investment roles, I specialize in community growth and management on Telegram, leveraging data-driven analysis and strategic insights to help projects expand their presence and engagement.",
      highlights: [
        "11+ years in Data Engineering & Analytics",
        "Experienced Crypto Industry Investor and Analyst since 2018",
        "Venture Capital Investor & Advisor",
        "Telegram Community Manager"
      ],
      gradient: "from-cyan-400 to-blue-500"
    },
    {
      id: 'xchng',
      name: 'XCHNG', 
      role: 'Co-founder & Telegram Specialist',
      telegramHandle: 'xXCHNGx',
      avatar: 'https://customer-assets.emergentagent.com/job_telegram-crypto-4/artifacts/rjga6bu8_XCHNG%20LOFI.jpg',
      description: "I am known as XCHNG, a trained IT specialist in system integration, with 12 years of experience in information technology, encompassing both professional and personal pursuits. Since 2017, I have been deeply engaged in the cryptocurrency sector, with a focus on blockchain infrastructure. In addition to my technical expertise, I specialize in delivering polished, professional design solutions, as well as community management and implementing robust security strategies to ensure project integrity and safety.",
      highlights: [
        "12 Years in Information Technology and System Integration",
        "Engaged in Cryptocurrency Sector since 2017, specializing in Blockchain Infrastructure",
        "Professional Design Solutions Expert",
        "Community Manager",
        "Security Strategist for Project Integrity and Safety"
      ],
      gradient: "from-purple-400 to-pink-500"
    }
  ];

  return (
    <section id="cofounders" className="py-14 px-4 min-h-screen flex flex-col justify-center">
      <div className="max-w-4xl mx-auto w-full">
        <div className="text-center mb-10">
          <h2 className="display-large mb-4">Meet the Team</h2>
          <p className="body-medium">
            The experienced team behind TG4Crypto's professional Telegram setup services.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {cofounders.map((cofounder) => (
            <div
              key={cofounder.id}
              className="relative group"
              onMouseEnter={() => setSelectedCofounder(cofounder.id)}
              onMouseLeave={() => setSelectedCofounder(null)}
            >
              <div 
                className={`
                  relative p-6 h-full border border-gray-800 dark-transition overflow-hidden rounded-lg
                  ${selectedCofounder === cofounder.id 
                    ? 'bg-gray-900 border-cyan-400' 
                    : 'bg-gray-950 hover:bg-gray-900'
                  }
                `}
                style={{
                  background: selectedCofounder === cofounder.id 
                    ? 'rgba(255, 255, 255, 0.05)' 
                    : 'rgba(18, 18, 18, 0.8)'
                }}
              >
                {/* Avatar and Basic Info */}
                <div className="flex flex-col items-center text-center mb-5">
                  <div 
                    className={`
                      w-20 h-20 rounded-full overflow-hidden border-2 border-gray-600 mb-4
                      ${selectedCofounder === cofounder.id ? 'border-cyan-400' : ''}
                    `}
                  >
                    <img 
                      src={cofounder.avatar}
                      alt={cofounder.name}
                      className="w-full h-full object-cover"
                      onError={(e) => {
                        e.target.src = 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64"><rect fill="%23374151" width="64" height="64"/><text x="32" y="38" font-size="24" text-anchor="middle" fill="%2300DAF0">?</text></svg>';
                      }}
                    />
                  </div>
                  <h3 className="text-xl font-semibold mb-1">{cofounder.name}</h3>
                  <p className="text-sm" style={{ color: 'var(--brand-primary)' }}>
                    {cofounder.role}
                  </p>
                </div>

                {/* Description - Always visible */}
                <div className="mb-4">
                  <p className="text-sm text-gray-400 leading-relaxed">
                    {cofounder.description}
                  </p>
                </div>

                {/* Highlights */}
                <div>
                  <h4 className="text-sm font-semibold mb-2 text-white">Key Expertise</h4>
                  <div className="space-y-1.5">
                    {cofounder.highlights.map((highlight, index) => (
                      <div key={index} className="flex items-start gap-2">
                        <Award size={14} className="flex-shrink-0 mt-0.5" style={{ color: 'var(--brand-primary)' }} />
                        <span className="text-sm text-gray-400">{highlight}</span>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Animated Background Effect */}
                {selectedCofounder === cofounder.id && (
                  <div className="absolute inset-0 pointer-events-none">
                    <div 
                      className={`absolute inset-0 opacity-10 bg-gradient-to-r ${cofounder.gradient}`}
                      style={{ animation: 'pulse 2s infinite' }}
                    />
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CofoundersSection;
